import * as React from "react";
const SvgIconCircleFull = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 100, height: 100, viewBox: "0 0 100 100", ...props }, /* @__PURE__ */ React.createElement("rect", { id: "Rechteck_7", "data-name": "Rechteck 7", width: 100, height: 100, rx: 50, ry: 50 }));
export default SvgIconCircleFull;
